import { Input, SelectField } from 'components/Profile';
import { insurancePlanTypes } from '../helper';
import Heading from './Heading';

const PlanDetails = ({ carrierOptions }) => (
  <>
    <Heading title="Your plan details" description="Three fields and you're done." />

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <SelectField
        name="insurance_company_id"
        label="Insurance carrier"
        placeholder="Select insurance carrier"
        options={carrierOptions}
      />

      <Input
        name="plan_type"
        label="Plan type"
        placeholder="Select plan"
        as="select"
        optional
      >
        <option value="" disabled>Select plan</option>
        {insurancePlanTypes.map(({ value, label }) => (
          <option key={value} value={value}>{label}</option>
        ))}
      </Input>

      <Input
        name="member_id"
        label="Member ID"
        placeholder="Member / subscriber ID"
      />

      <Input
        name="group_number"
        label="Group number"
        placeholder="Group #"
        optional
      />
    </div>
  </>
);

export default PlanDetails;
